import { queryOptions } from '@tanstack/react-query';
import { userServiceRepository } from 'services/api/userService/ApiUserServiceRepository';
import { QueryKeys } from 'utils/queryKeys';

export type CurrentUserVerification = {
  emailVerified: boolean | null;
  userId: string;
  email: string;
  pendingEmail: string | null;
};

export const currentUserVerificationQueries = {
  currentUser: queryOptions({
    queryKey: QueryKeys.currentUserVerification,
    queryFn: () => userServiceRepository.getCurrentUser(),
    select: (data): CurrentUserVerification => ({
      emailVerified: data.emailVerified,
      userId: data.id,
      email: data.email ?? '',
      pendingEmail: data.pendingEmail,
    }),
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
  }),
};
